/**
 * Insert a html script in the page
 * @param document
 * The current page
 * @param src
 * Script source
 */
export function insertScriptToDocument(document: Document, src: string): void {
  const tag = "script";
  const scriptTag = document.createElement(tag) as HTMLScriptElement; // create a script tag
  scriptTag.defer = true;
  const firstScriptTag = document.getElementsByTagName(tag)[0] as HTMLScriptElement; // find the first script tag in the document
  scriptTag.src = src; // set the source of the script to your script
  firstScriptTag?.parentNode?.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}
